import { useSortable } from "@dnd-kit/sortable";
import { SHStack, SHStackProps } from "@components/design-systems";

export type SHSortableItemProps = {
  itemId: string;
  children?: string | JSX.Element;
} & SHStackProps;

export const SHSortableItem = ({
  itemId: id,
  children,
  ...others
}: SHSortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  return (
    <SHStack
      className="SHSortableItem"
      ref={setNodeRef}
      sx={{
        transform: transform
          ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
          : undefined,
        transition,
        ":hover": {
          cursor: "grab",
        },
        ":active": {
          cursor: "grabbing",
        },
      }}
      {...attributes}
      {...listeners}
      {...others}
    >
      {children}
    </SHStack>
  );
};
